// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"76203e6f","240":"76a99bd0","241":"7ade5908","300":"1756f622","395":"025e91e7","570":"ce7851f5","617":"9669dbfe","649":"00f1a301","754":"758c1891","960":"22200c2b"}[chunkId] + ".chunk.js";
};